import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { RestService } from 'app/shared/rest.service';
import * as moment from "moment";
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { AddressesService } from '../../service/addresses.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { setting } from '../../../../../../setting';
import { NotFoundModalComponent } from 'app/shared/modals/not-found-modal/not-found-modal.component';
import { ItineraryService } from 'app/shared/itinerary.service';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-flights',
  templateUrl: './flights.component.html',
  styleUrls: ['./flights.component.scss'],
  providers: [AddressesService]
})
export class FlightsComponent implements OnInit, OnDestroy {

    @Input() _close: boolean;
    @Input() getClientsSettingAppBooking: any;

    @Output() payload = new EventEmitter<any>();
    @Output() results = new EventEmitter<any>();
    @Output() isLoading = new EventEmitter<boolean>();
    @Output() origin = new EventEmitter<any>();
    @Output() modal = new EventEmitter<string>();

    @ViewChild('triggerButton') triggerButton: ElementRef;
    @ViewChild('cardSelectorRoom') cardSelectorRoom: ElementRef;
    @ViewChild('datePicker', { read: ElementRef }) datePickerInput: ElementRef;
    @ViewChild('datePicker_', { read: ElementRef }) datePickerInput2: ElementRef;

    _form!: FormGroup;
    loadingData: boolean = false;
    validateButtonSearch: boolean = false;
    itineraryActive: any[] = [];
    componentResults: boolean = false;
    _findData: boolean;
    _resultsQuery: any;
    _longDestination: string;
    dateRange: any;
    routerStorage: any;
    config = {
      animated: true,
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true
    };

    pickup: any;
    dropoff: any;
    countryPickupLocation: string;
    countryDropoffLocation: string;
    selectediataCodeDestiny: any;
    selectediataCodeOrigin: any;
    originInputValue: string = '';
    destinationInputValue: string = '';

    destinationOptions : Observable<any[]> = of([]);
    destinationOptions_: Observable<any[]> = of([]);
    isHovered: boolean = false;

    countryIataOrigin:string;
    countryIataDestiny:string;

    // minDate: dayjs.Dayjs = dayjs().subtract(0, 'days');
    // maxDate: dayjs.Dayjs = dayjs().add(12, 'month');
    isCollapsed = false;
    dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
    now = new Date();
    minDate: Date;

    _maxPersons: any;
    passengers: string;
    private closing = false;

    showModal: boolean = false;
    titleModal: string = 'Advertencia';
    messageModal: string = 'Cree un file en la barra superior para poder iniciar una búsqueda';
    selectedWay: string = 'way';

    selectedNoDateDefined: boolean = false;

    bsModalRef?: BsModalRef;
    bgClientColor: string = 'black';
    bookingFlowSidebar: any;
    backgroundDisplayContrast: any;


    originOptionsLegs: any[] = [];
    destinationOptionsLegs: any[] = [];


    wayArr: any[] = [
      {value: 'way', label: 'Ida'},
      {value: 'twoWay', label: 'Ida y vuelta'},
      {value: 'multi', label: 'Multidestino'}
    ]
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
              private formBuilder: FormBuilder,
              public userService: UserService,
              private _restService: RestService,
              private _router: Router,
              private notificationService: NotificationService,
              private _addressService: AddressesService,
              private modalService: BsModalService,
              private cdr: ChangeDetectorRef,
              private _itineraryService: ItineraryService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() public dialogRef: MatDialogRef<FlightsComponent>
  ) { }

  ngOnInit(): void {
                    const now = new Date();
                this.now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                this.dpConfig = { dateInputFormat: 'DD/MM/YYYY'  };
                this.minDate = new Date();
                this.minDate.setDate(this.minDate.getDate() + 1);
                this._maxPersons = Array.from(Array(100).keys());
                this.passengers = 'Pasajeros';
                this.routerStorage = setting.apiStorageBooking;
                this.componentResults = this.data && this.data?.component === 'results' ? true : false;
                     if(this.componentResults) {
                          this.loadingData = true;
                     }
                this.itineraryActive = this.userService.itineraryActive;
                this.clientData();
                this.initForm();

                this._itineraryService.itinerary$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                  this.cdr.detectChanges();
                });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

    clientData(): void {
    if(this.data && this.data?.clientSetting) {
                  this.getClientsSettingAppBooking = this.data?.clientSetting;
                }
    this.bgClientColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
    this.bookingFlowSidebar = JSON.parse(this.getClientsSettingAppBooking.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundDisplayContrast = this.bookingFlowSidebar?.background_color;
  }

  initForm(): void {
    // Formulario principal
    this._form = this.formBuilder.group({
      cabinClass: new FormControl(''),
      airlines: new FormControl([]),
      legs: this.formBuilder.array([]),  // FormArray para los legs
      passengers: this.formBuilder.group({
        adults: [1, [Validators.required, Validators.min(1)]],
        children: [[]],
        infants: [0]
      })
    });

    // Agregar primer leg por defecto
    this.addLeg();

    // Configurar suscripciones para autocompletado
    // this.setupLegSubscriptions();
  }


// Agregar un nuevo leg
addLeg(): void {
  const legsArray = this._form.get('legs') as FormArray;

  const legGroup = this.formBuilder.group({
    origin: ['', Validators.required],
    originData: [null],
    destination: ['', Validators.required],
    destinationData: [null],
    date: ['', Validators.required]
  });

  legsArray.push(legGroup);

  // Configurar suscripciones para este nuevo leg
  this.setupLegAutocomplete(legGroup, legsArray.length - 1);
}

// Eliminar un leg
removeLeg(index: number): void {
  const legsArray = this._form.get('legs') as FormArray;
  if (legsArray.length > 1) {  // Mínimo 1 leg
    legsArray.removeAt(index);
  }
}

// Configurar autocompletado para un leg específico
private setupLegAutocomplete(legGroup: FormGroup, index: number): void {
  // Origen
  legGroup.get('origin')?.valueChanges.pipe(
    filter(value => !!value && typeof value === 'string'),
    debounceTime(300)
  ).subscribe(searchValue => {
    this.loadLocations(searchValue, 'origin', index);
  });

  // Destino
  legGroup.get('destination')?.valueChanges.pipe(
    filter(value => !!value && typeof value === 'string'),
    debounceTime(300)
  ).subscribe(searchValue => {
    this.loadLocations(searchValue, 'destination', index);
  });
}

// Cargar ubicaciones para un leg específico
loadLocations(searchValue: string, type: 'origin' | 'destination', legIndex: number): void {
  if (!searchValue || searchValue.length < 2) return;

  const options$ = this._addressService.getLocationsAll(
    searchValue,
    type === 'origin' ? this.countryPickupLocation : this.countryDropoffLocation,
    false,
    'FLIGHTS'
  );

  if (type === 'origin') {
    this.originOptionsLegs[legIndex] = options$;
  } else {
    this.destinationOptionsLegs[legIndex] = options$;
  }
}

// Seleccionar ubicación
selectLocation(option: any, type: 'origin' | 'destination', legIndex: number): void {
  const legsArray = this._form.get('legs') as FormArray;
  const legGroup = legsArray.at(legIndex) as FormGroup;

  const locationData = option.data;
  const locationCode = locationData.iata || locationData.code;

  legGroup.patchValue({
    [type]: locationCode,
    [`${type}Data`]: locationData
  });
}

  // initForm(): void {
  //   this._form = this.formBuilder.group({
  //     origin: new FormControl('', Validators.required),
  //     destination: new FormControl('', Validators.required),
  //     arrivalDate: new FormControl(this.minDate, Validators.required),
  //     departureDate: new FormControl(null),
  //     market: 1,
  //     currency: 'USD',
  //     cabinClass: new FormControl(''),
  //     airlines: new FormControl([])
  //   });


  //    this._form.get('origin')?.valueChanges.pipe(
  //         filter(selectedValue => !!selectedValue),
  //       ).subscribe((selectedValue) => {
  //         this.destinationOptions = this._addressService.getLocationsAll(
  //           selectedValue,
  //           this.countryDropoffLocation,
  //           false,
  //           'FLIGHTS'
  //         );
  //       });

  //   this._form.get('destination')?.valueChanges.pipe(
  //         filter(selectedValue => !!selectedValue),
  //         ).subscribe((selectedValue) => {
  //           this.destinationOptions_ = this._addressService.getLocationsAll(
  //             selectedValue,
  //             this.countryPickupLocation,
  //             false,
  //             'FLIGHTS'
  //           );
  //         });

  //         if(this.componentResults) {
  //           this.formPatchValue();
  //         }

  // }

  formPatchValue(): void {
      if(this.data && this.data?.category) {

      if(!this.data.payload) {
        this.loadingData = false;
        return;
      }

      if(this.data.category !== this.data.payload[0].categoriesId[0]) {
        this.loadingData = false;
        return;
      }

      const payload = this.data.payload[0];


      if(!payload) {
        this.loadingData = false;
        return;
      }

      this.loadingData = false;
    }
  }

  /***********************************************Auto Complete********************************************/

  /**
 * Capitaliza una cadena de texto
 *
 * Convierte la cadena a minúsculas, la divide por espacios y pone en mayúscula
 * la primera letra de cada palabra.
 *
 * @val -> string a capitalizar
 * @return -> string con cada palabra capitalizada
 */

capitalize(val: any): string {
  if (!val && val !== 0) return ''; // Manejar null, undefined, empty string, pero mantener 0

  return String(val)
    .toLowerCase()
    .trim()
    .split(/\s+/) // Divide por uno o más espacios
    .filter(word => word.length > 0) // Filtra palabras vacías
    .map(word => {
      // Encontrar el primer carácter alfabético
      const firstLetterMatch = word.match(/[a-zñáéíóúü]/i);

      if (firstLetterMatch) {
        const firstLetterIndex = firstLetterMatch.index || 0;
        // Capitalizar la primera letra alfabética encontrada
        return word.substring(0, firstLetterIndex) +
               word[firstLetterIndex].toUpperCase() +
               word.substring(firstLetterIndex + 1);
      }

      // Si no hay letras, devolver la palabra tal cual
      return word;
    })
    .join(' ');
}

  /**
 * Método para mostrar el nombre de una ubicación.
 *
 * Este método construye y devuelve una cadena con el nombre del hotel, la dirección, el código IATA, el código de destino
 * o el código de país de la ubicación. La información es extraída del objeto `name`.
 *
 * @name -> objeto que contiene la información de la ubicación, como `hotel_name`, `address`, `iata`, `destination_code`, `country_code`.
 * @returns -> una cadena con el nombre y la información adicional de la ubicación.
 */
displayFn(name): string {
  if(name) {
    return `${name.hotel_name ? name.hotel_name : name.name} ${name.address ? "("+name.address+")": ''}${name.iata ? "("+name.iata+")": ''}${name.destination_code ? "("+name.destination_code+")": ''}${name.country_code ? "("+name.country_code+")": ''}`;
  } else {
    return '';
  }
}

/**
 * Método para obtener todas las ubicaciones según el tipo.
 *
 * Este método asigna valores a las ubicaciones de origen y destino en el formulario, basándose en el tipo
 * (origen o destino) y los datos proporcionados. Además, establece valores y valida los campos en el formulario.
 *
 * @keyword -> objeto que contiene la información de la ubicación, como `destination_code`, `id`, `address`.
 * @type -> tipo de ubicación, que puede ser 'origin' o 'destination'.
 */
async getLocationsAll(selected: {data: any, type: string}, inputType: string) {
  const keyword = selected.data;
  const type = selected.type;
  if (keyword) {
    switch (inputType) {

      case 'origin':
          keyword.type = type;
          this.pickup = { id: keyword?.id ?? null, name: null, latitude: null, longitude: null};
          this._form.get('origin')?.setValue(keyword); // Asignamos el objeto completo
          this._form.get('origin')?.setErrors(null);
          this._form.get('origin')?.updateValueAndValidity();
          this.countryPickupLocation = keyword?.country_code;
          switch(type) {
            case 'airport':
              this.selectediataCodeOrigin = keyword.iata;
              this.originInputValue = `${keyword.name}, ${keyword.country_code} (${keyword.iata})`;
              this.pickup['address']= keyword.iata.replace(/[()]/g, '');
              this.pickup['type']= 'airport';
              this.pickup['origin'] = keyword.country_code;
               this.pickup['name'] = keyword.name;
              break;
            case 'city':
              this.originInputValue = keyword.display;

              try {
              // Convertir Observable a Promise usando lastValueFrom (RxJS 7+)

              const res = await this._restService.doGet('api', `/utilities/searchlocations?address=true&placeId=${keyword.place_id}`)
                    .toPromise();

              if(res.addressGoogle) {
                this.selectediataCodeOrigin = res.addressGoogle.iata;
                this.pickup['name'] = res.addressGoogle.name;
                this.pickup['longitude'] = res.addressGoogle.longitude;
                this.pickup['latitude'] = res.addressGoogle.latitude;
                this.pickup['address'] = res.addressGoogle.address;
                this.pickup['type'] = 'city';
                this.pickup['origin'] = res.addressGoogle.iata;
              }
            } catch (error: any) {
              console.error('Error fetching city data:', error);
              // Manejar el error
            }
            break;
            case 'hotel':
                this.selectediataCodeOrigin = keyword.address;
                this.originInputValue = `${keyword.name}, ${keyword.city_name}`;
                this.pickup['address'] = keyword.address.replace(/[()]/g, '');
                this.pickup['type']= 'hotel';
                this.pickup['origin'] = keyword.iata;
                this.pickup['name'] = keyword.name;
                this.pickup['longitude'] = keyword.longitude;
                this.pickup['latitude'] = keyword.latitude;
              break;
            case 'restaurant':
            case 'attraction':
                this.selectediataCodeOrigin = keyword.address;
                this.pickup['address'] = keyword.address.replace(/[()]/g, '');
                this.originInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.pickup['type'] = type;
                this.pickup['origin'] = keyword.iata;
              break;
            case 'train':
            case 'bus':
            case 'port':
                this.selectediataCodeOrigin = keyword.iata;
                this.pickup['address'] = keyword.iata.replace(/[()]/g, '');
                this.originInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.pickup['type'] = type;
                this.pickup['origin'] = keyword.iata;
              break;
          }

        if(keyword.id === this._form.get('firstDestination')?.value?.id &&
           this.pickup['type'] === this.dropoff?.['type'] &&
          this.pickup['name'] === this.dropoff?.['name'] &&
          this.pickup['longitude'] === this.dropoff?.['longitude'] &&
          this.pickup['latitude'] === this.dropoff?.['latitude']) {
          this.notificationService.info('El pickup no puede ser igual que el dropoff');
          this.resetInputsOriginDestination('origin');
          return;
        }

        break;
      case 'destination':
          keyword.type = type;
          this.dropoff = { id: keyword?.id ?? null, name: null, latitude: null, longitude: null};

          this._form.get('destination')?.setValue(keyword); // Asignamos el objeto completo
          this._form.get('destination')?.setErrors(null);
          this._form.get('destination')?.updateValueAndValidity();
          this.countryDropoffLocation = keyword.country_code;

          switch(type) {
            case 'airport':
              this.selectediataCodeDestiny = keyword.iata;
              this.destinationInputValue = `${keyword.name}, ${keyword.country_code} (${keyword.iata})`;
              this.dropoff['address']= keyword.iata.replace(/[()]/g, '');
              this.dropoff['type']= 'airport';
              this.dropoff['destination'] = keyword.country_code;
              this.dropoff['name'] = keyword.name;
              break;
            case 'city':
                this.destinationInputValue = keyword.display;

              try {
              // Convertir Observable a Promise usando lastValueFrom (RxJS 7+)

              const res = await this._restService.doGet('api', `/utilities/searchlocations?address=true&placeId=${keyword.place_id}`)
                    .toPromise();

              if(res.addressGoogle) {
                this.selectediataCodeDestiny = res.addressGoogle.iata;
                this.dropoff['name'] = res.addressGoogle.name;
                this.dropoff['longitude'] = res.addressGoogle.longitude;
                this.dropoff['latitude'] = res.addressGoogle.latitude;
                this.dropoff['address'] = res.addressGoogle.address;
                this.dropoff['type'] = 'city';
                this.dropoff['destination'] = res.addressGoogle.iata;
              }
            } catch (error: any) {
              console.error('Error fetching city data:', error);
              // Manejar el error
            }
              break;
            case 'hotel':
                this.selectediataCodeDestiny = keyword.address;
                this.destinationInputValue = `${keyword.name}, ${keyword.city_name}`;
                this.dropoff['address'] = keyword.address.replace(/[()]/g, '');
                this.dropoff['type']= 'hotel';
                this.dropoff['destination'] = keyword.iata;
                this.dropoff['name'] = keyword.name;
                this.dropoff['longitude'] = keyword.longitude;
                this.dropoff['latitude'] = keyword.latitude;
              break;
            case 'restaurant':
            case 'attraction':
                this.selectediataCodeDestiny = keyword.address;
                this.dropoff['address'] = keyword.address.replace(/[()]/g, '');
                this.destinationInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.dropoff['type'] = type;
                this.dropoff['destination'] = keyword.iata;
              break;
            case 'train':
            case 'bus':
            case 'port':
                this.selectediataCodeDestiny = keyword.iata;
                this.dropoff['address'] = keyword.iata.replace(/[()]/g, '');
                this.destinationInputValue =  `${keyword.name}, ${keyword.city_name}, ${keyword.country_name}`;
                this.dropoff['type'] = type;
                this.dropoff['destination'] = keyword.iata;
              break;
            }

        if(keyword.id === this._form.get('firstOrigin')?.value.id &&
         this.dropoff['type'] === this.pickup?.['type'] &&
          this.dropoff['name'] === this.pickup?.['name'] &&
          this.dropoff['longitude'] === this.pickup?.['longitude'] &&
          this.dropoff['latitude'] === this.pickup?.['latitude']) {
          this.notificationService.info('El dropoff no puede ser igual que el pickup');
          this.resetInputsOriginDestination('destination');
          return;
        }

        break;
    }
  }

}

/**
 * Resetea los valores de origen o destino
 *
 * Este método se utiliza para limpiar los campos del formulario
 * relacionados con el origen o destino, dependiendo del tipo recibido.
 *
 * @type -> parámetro de tipo string que puede ser 'origin' o 'destination'
 *
 * 'origin':
 *  - Limpia `originInputValue`
 *  - Setea el campo 'firstOrigin' del formulario en null
 *  - Reinicia `pickup` y `selectediataCodeOrigin`
 *
 * 'destination':
 *  - Limpia `destinationInputValue`
 *  - Setea el campo 'firstDestination' del formulario en null
 *  - Reinicia `dropoff` y `selectediataCodeDestiny`
 *
 * @form -> formulario reactivo al que se le reinician campos específicos
 */
resetInputsOriginDestination(type: string) {
  switch(type) {
    case 'origin':
      this.originInputValue = undefined;
      this._form.get('firstOrigin')?.setValue(null);
      this.pickup = undefined;
      this.selectediataCodeOrigin = undefined;
      this.countryPickupLocation = undefined;

      break;
    case 'destination':
      this.destinationInputValue = undefined;
      this._form.get('firstDestination')?.setValue(null);
      this.dropoff = undefined;
      this.selectediataCodeDestiny = undefined;
      this.countryDropoffLocation = undefined;
      break;
    default:
      break;
  }
}

  _onSubmit(form, event): void {

    // const payload = [{
    //     "categoriesId": [
    //         3
    //     ],
    //     "others": {
    //         "tours": {
    //             "adults": 1,
    //             "children": []
    //         }
    //     },
    //     "origin": "BOG",
    //     "destination": "MIA",
    //     "arrivalDate": "2026-06-18",
    //     "departureDate": null,
    //     "market": 1,
    //     "currency": "USD",
    //     "cabinClass": "",
    //     "airlines": []
    // }]

    const payload =  true // this.buildPayload();

    if(!payload) {
      return;
    }

    localStorage.setItem("form", JSON.stringify(form.value));

      if (localStorage.getItem("payload")) {
        localStorage.removeItem("payload");
      }

      localStorage.setItem("payload", JSON.stringify([payload]));

       if(this.componentResults) {
        this.dialogRef.close(payload);
        localStorage.setItem('origin', 'FLIGHTS');
    } else {

      this._emitLoading(true);
      this._restService.doPost("app", "search", payload).subscribe({
        next: (response: any) => {
          console.log(response)
          if(response !== null && response.results && response.results.flights && Array.isArray(response.results.flights) && response.results.flights.length > 0) {

            const payloadArray = [payload]
            this.payload.emit(payloadArray);
            this._colocarSearchIdEnlosHoteles(response);
            // this._setArrivalAndDepartureDate(response, form);
            this._handleResponse(response, "FLIGHTS", form);
            this._emitOrigin("FLIGHTS");
            this._emitLoading(false);
            this._router.navigate(["/results"]);

          } else {
                this._emitLoading(false);
                const initialState: ModalOptions = {
                  initialState: {
                    message: '',
                    confirmText: 'Cerrar',
                    cancelText: 'Volver a intentar',
                    showCancelButton: true,
                    size: 'sm',
                  }
                };
                const modalOptions = Object.assign({}, initialState, this.config);
                this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);
                  }
                const confirmSubscription = this.bsModalRef?.content?.confirmResult.subscribe((result: boolean) => {
                  if(result) {
                      if (result) {
                        this._onSubmit(form, event);
                          } else {
                            this.bsModalRef.hide();
                            this._router.navigate(["/home"]);
                          }
                        } else {

                        }
                      });
        },
        error: (error: HttpErrorResponse) => {

        }
      });
    }
  }

  buildPayload(){
    console.log(this._form)
    // return {
    //   categoriesId: [3],
    //   others: {
    //     tours: {
    //       adults: 1,
    //       children: [],
    //     }
    //   },
    //   origin: this._form.get('origin')?.value?.iata,
    //   destination: this._form.get('destination')?.value?.iata,
    //   arrivalDate: this.formatDateToISO(this._form.get('arrivalDate')?.value),
    //   departureDate: this.formatDateToISO(this._form.get('departureDate')?.value),
    //   market: 1,
    //   currency: 'USD',
    //   cabinClass: this._form.get('cabinClass')?.value,
    //   airlines: this._form.get('airlines')?.value
    // }
  }

  private formatDateToISO(date: any): string | null {
  if (!date) return null;

  // Si es un objeto con start/end (rango)
  if (date.start) {
    return moment(date.start).format('YYYY-MM-DD');
  }

  // Si es fecha directa
  return moment(date).format('YYYY-MM-DD');
}


    /**
 * Emite el estado de loading y actualiza el estado interno de búsqueda
 *
 * Este método comunica el estado de carga al componente padre y actualiza
 * la variable interna que controla la visualización del estado de búsqueda.
 *
 * @param {boolean} isLoading - Estado de carga: true si está cargando, false si completó
 * @returns {void}
 *
 * @emits
 * - isLoading: Evento boolean que indica el estado de carga
 *
 * @sideEffects
 * - Actualiza this._findData con el estado de loading
 * - Permite sincronizar el estado interno con la emisión al padre
 *
 * @usage
 * Utilizado durante las operaciones de búsqueda para mostrar/ocultar spinners
 * y prevenir interacciones duplicadas durante la carga
 */
  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }

    /**
   * Asigna el searchId de la respuesta a cada habitación en los resultados de hoteles
   *
   * Este método procesa la respuesta de búsqueda y propaga el searchId a nivel de
   * habitación para facilitar el tracking y futuras operaciones con cada habitación.
   *
   * @param {any} response - Respuesta completa del servicio de búsqueda
   * @returns {void}
   *
   * @process
   * 1. Verifica que la respuesta no sea nonAvailable
   * 2. Itera sobre cada habitación en additionalInfo.rooms
   * 3. Asigna el searchId de la respuesta a cada habitación
   *
   * @structure
   * - response.searchId: ID único de la búsqueda
   * - response.results[0]?.additionalInfo.rooms: Array de habitaciones
   *
   * @purpose
   * - Facilitar operaciones individuales por habitación usando el searchId
   * - Mantener consistencia en el tracking de la búsqueda
   */
    _colocarSearchIdEnlosHoteles(response: any) {
      if(!response.results.nonAvailable){
        response.results[0]?.additionalInfo.rooms.forEach((obj) => {
          obj.room.searchId = response.searchId;
        });
      }
    }


    /**
   * Establece las fechas de llegada y salida en los resultados de la búsqueda
   *
   * Este método formatea y asigna las fechas del rango seleccionado al objeto
   * de resultados, normalizándolas al formato ISO 8601 (YYYY-MM-DD).
   *
   * @param {any} response - Objeto de respuesta donde se asignarán las fechas
   * @param {FormGroup} form - Formulario (no utilizado actualmente en este método)
   * @returns {void}
   *
   * @formatting
   * - Usa moment.js para parsing y formateo consistente
   * - Formato de salida: "YYYY-MM-DD" (ISO 8601)
   *
   * @source
   * - this.dateRange.start.$d: Fecha de inicio del rango
   * - this.dateRange.end.$d: Fecha de fin del rango
   *
   * @processing
   * - Convierte Date object a string
   * - Split por coma para obtener solo la parte de la fecha
   * - Formatea a YYYY-MM-DD
   */
    _setArrivalAndDepartureDate(response: any, form) {
        response.results.dateIni = moment(this.dateRange.start.$d.toString().split(",")[0]).format("YYYY-MM-DD");
        response.results.dateEnd = moment(this.dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD");

    }

      /**
     * Procesa y normaliza la respuesta de búsqueda para su uso en la aplicación
     *
     * Este método centraliza el manejo de la respuesta del API, agregando metadatos,
     * manejando casos edge de no resultados, y emitiendo los resultados normalizados.
     *
     * @param {any} response - Respuesta cruda del servicio de búsqueda
     * @param {string} categoryName - Nombre de la categoría de búsqueda
     * @param {FormGroup} form - Formulario asociado a la búsqueda
     * @returns {void}
     *
     * @processing
     * 1. ✅ Verifica que response y response.results no sean null
     * 2. ✅ Agrega metadatos: categoryName, arrivalDate, destination
     * 3. ✅ Maneja caso de array vacío con mensaje descriptivo
     * 4. ✅ Adjunta el formulario completo a los resultados
     * 5. ✅ Emite resultados normalizados mediante EventEmitter
     *
     * @errorHandling
     * - Try-Catch: Maneja excepciones inesperadas durante el procesamiento
     * - Fallback: Restablece page a 1 en caso de error
     *
     * @emits
     * - results: Array de resultados procesados y normalizados
     */
      _handleResponse(response: any, categoryName: string, form: FormGroup) {
        console.log(response)
        if (response && response.results != null) {
          try {
            this._resultsQuery = response.results;
            delete this._resultsQuery?.dateEnd;
            delete this._resultsQuery?.dateIni;
            this._resultsQuery.categoryName = categoryName;
            this._resultsQuery.arrivalDate = moment(this.dateRange.end.$d.toString().split(",")[0]).format("YYYY-MM-DD"); // form.value['arrivalDate'];
            this._resultsQuery.destination = this._longDestination;

            if (!response.results.length) {
              this._resultsQuery.noResultMessage = "No results found for the search";
            }
            // se anexa el formulario actual
            this._resultsQuery.form = form;
            const arrayResults = [this._resultsQuery];
            this.results.emit(arrayResults);
          } catch (e) {
            this._resultsQuery = [];
            this._restService.page = 1;
          }
        } else {
          this._resultsQuery = [];
          this._resultsQuery.noResultMessage = "No results found for the search";
          this.results.emit(this._resultsQuery);
        }
      }

        /**
       * Emite el origen de la búsqueda a través de un EventEmitter
       *
       * Este método permite comunicar el tipo de origen (categoría) de la búsqueda
       * al componente padre mediante un evento emitido.
       *
       * @param {any} origin - Origen/categoría de la búsqueda (ej: "HOTELS", "FLIGHTS")
       * @returns {void}
       *
       * @emits
       * - origin: Evento que contiene el tipo de origen de la búsqueda
       *
       * @usage
       * Utilizado para informar al componente padre sobre el contexto de la búsqueda
       * realizada, permitiendo diferentes comportamientos basados en la categoría
       */
        _emitOrigin(origin: any) {
          this.origin.emit(origin);
        }

              close(): void {

          this.dialogRef.close(null);
        }

          /**
        * Método para obtener la imagen del logotipo de la agencia.
        *
        * Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
        * Si la imagen no está disponible o es igual a la ruta del archivo de la API,
        * retorna una imagen por defecto.
        *
        * @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
        */
        get agencyImagen(): string {
          let agencyImagen = this.userService._imagen_logotype;
          if (agencyImagen === this.routerStorage || agencyImagen === '') {
              return agencyImagen =  'assets/img/sin-logo.png';
          } else {
              return agencyImagen;
          }
        }

        /**
       * Método para intercambiar las ubicaciones de origen y destino.
       *
       * Este método intercambia los valores de origen y destino en el formulario. Los valores se toman de los campos
       * `firstOrigin` y `firstDestination` y luego se aplican en el formulario usando `patchValue`.
       */
      swapLocations() {
        // Intercambiar valores del formulario
        const origin = this._form.get('origin')?.value;
        const destination = this._form.get('destination')?.value;

        this._form.patchValue({
          origin: destination,
          destination: origin
        });

        // Intercambiar pickup y dropoff
        const tempPickup = this.pickup;
        this.pickup = this.dropoff;
        this.dropoff = tempPickup;

        // Intercambiar códigos IATA
        const tempIata = this.selectediataCodeOrigin;
        this.selectediataCodeOrigin = this.selectediataCodeDestiny;
        this.selectediataCodeDestiny = tempIata;

        //seteamos los iata de cada destino.
        this.countryIataOrigin = this.pickup.destination;
        this.countryIataDestiny = this.dropoff.origin;

        // Intercambiar los valores visuales de los inputs
        const tempInputValue = this.originInputValue;
        this.originInputValue = this.destinationInputValue;
        this.destinationInputValue = tempInputValue;
      }

            /**
       * Método para abrir el modal.
       *
       * Este método cambia el estado de la variable `isCollapsed` a `true`, y la variable `_close` a `false`.
       * Después de un pequeño retardo, emite un evento con el valor 'true' para abrir el modal.
       */
      _openModal() {
        // this.applyImageFilter();
        this.isCollapsed = true;
        this._close = false;
        this.closing = false;
        setTimeout(() => {
          this.modal.emit('true');
        }, 100);
      }
/**
 * Abre el modal principal
 *
 * Este método establece la propiedad `showModal` en `true`
 * para mostrar el modal asociado.
 *
 * @showModal -> estado booleano que determina si el modal está activo
 */
fileActive() {
  this.showModal = true;
}

/**
 * Cierra el modal principal
 *
 * Este método cambia la propiedad `showModal` a `false`
 * para cerrar el modal que fue previamente abierto.
 *
 * @showModal -> se establece en falso para cerrar el modal
 */
closeModal() {
  this.showModal = false;
}

    filePaid():void{
    if(this.validateButtonSearch){
      this.titleModal = 'File Completado',
      this.messageModal = 'Este file se encuentra completado, por favor, crea un nuevo file para hacer una búsqueda'
      this.showModal = true;
    }
  }

  changeWay(event: string): void {
    if(event) {
      this.selectedWay = event;
    }
  }

  getStyleBackgroundReturn(): string {

  if(this.selectedWay !== 'way') {
    return 'white';
  } else {
    return '#effef9';
  }

}

noDateDefined(event: any): void {
  const isChecked = event.target.checked;

  this.selectedNoDateDefined = isChecked;

  if (isChecked) {
    this._form.get('arrivalDate')?.setValue(null);
    this._form.get('departureDate')?.setValue(null);
  } else {
    this._form.get('arrivalDate')?.setValue(this.minDate);
    if(this.selectedWay !== 'way') {
       this._form.get('departureDate')?.setValue(this.minDate);
    }

  }
}

onDateSelected(event): void {
  console.log(event)
  this._form.get('arrivalDate')?.setValue(event);
}

onSubmit(): void {

}

}
